// src/pages/CapabilitiesV3TestPage.js
// Test page for V3 clean sticky implementation

import React from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import CapabilitiesV3 from '../components/capabilities-v3/CapabilitiesV3';
import SEO from '../components/SEO';
import './CapabilitiesTestPage.css'; // Reuse existing styles

// Blank spacer section
const SpacerSection = ({ id, label }) => (
  <section
    className="spacer-section"
    id={id}
  >
    <div className="spacer-section__label">
      {label || (id === 'spacer-top' ? 'Scroll Down to Test Sticky Pill' : 'End of Section')}
    </div>
  </section>
);

function CapabilitiesV3TestPage() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });

  return (
    <>
      {/* SEO - noindex test page */}
      <SEO
        title="Capabilities V3 Test"
        noindex={true}
      />

      {/* Progress Bar */}
      <motion.div
        className="progress-bar"
        style={{ scaleX }}
      />

      {/* Back to Home Link */}
      <Link to="/" className="back-link">
        <ArrowLeft size={18} />
        <span>Back to Home</span>
      </Link>

      {/* Section 1: Blank Spacer (100vh) */}
      <SpacerSection id="spacer-top" label="V3 Test - Scroll Down" />

      {/* Section 2: Capabilities V3 (500vh) */}
      <CapabilitiesV3 />

      {/* Section 3: Blank Spacer (100vh) */}
      <SpacerSection id="spacer-bottom" label="Section Ended - Pill Should Have Scrolled Away" />
    </>
  );
}

export default CapabilitiesV3TestPage;
